<template>
    <div style="margin-top: 55px;">
        <spinner :data="spinnerData"></spinner>
        <all-feeds :feeds="mainFeed" feed-status="true" ></all-feeds>
    </div>
</template>

<script>
    import {mapState} from "vuex";
    import ImageDisplay from "../../components/Home/imageDisplay";
    import avta from "@/functions/getAvatar";
    import AllFeeds from "../../components/Home/allFeeds";

    export default {
        name: "index",
        components: {AllFeeds},
        data() {
            return {
                feed: {},
                mainFeed: [],
                spinnerData: {},
                selectedFeed: '',
                formModelComment: {
                    comment: "",
                },
                selectedVideoId: '',
            }
        },
        computed: mapState({
            getSelectedReview: state => state.selectedReview,
            getUserDetails: state => state.user,
        }),
        watch: {
            feed(val) {
                this.mainFeed.push(val)
            },
        },
        mounted() {
            this.setSelectedReview()
        },
        methods: {
            // time ago function
            timeAgoFunction(timestamp) {
                return this.$timeAgo.format(new Date(timestamp * 1000));
            },
            selectFeed(feed) {
                this.$store.commit('selectedImageFeed', feed);
                this.selectedFeed = feed;
            },
            showLoading(options = {}) {
                let loader = this.spinnerData = {
                    spinner: 'Jumper',
                    isLoading: options.show !== undefined ? options.show : true ,
                    color: '#00bfff',
                    size: '60px',
                    options: 'center relative',
                };
                return loader;
            },
            setSelectedReview() {
                if (this.getSelectedReview.review_id) {
                    this.feed = this.getSelectedReview
                }else {
                    const slug = this.$route.params.tweet_slug;
                    let uid = 0;
                    if (this.getUserDetails.id) {
                        uid = this.getUserDetails.id;
                    }
                    this.axios
                    .get(`/timeline/reviews/single/${slug}/${uid}`)
                    .then(res => {
                        // console.log(res.data.data.review)
                        this.feed = res.data.data.review
                    })
                    .catch(err => {
                        console.log(err)
                    })
                }
            },
            // open individual comment box
            openCommentBox(index) {
                // toggle bet show and hide of comment list
                $(".comments-list").toggleClass("hide");
                // toggle bt hide and show of comment box
                $("#comment" + index).toggleClass("hide");
                // clear response message
                $("#comment" + index + " .commentResponse").html("");
                // clear text box
                $("#comment" + index + " textarea").val("");
            },
            setCommentBoxId(index) {
                return "comment" + index;
            },
            reviewUserAvatar(avatar) {
                return avta({local:{ av: null, us: avatar }});
            },
            urlify(text) {
                var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
                if (text === null || text === '') {
                    text = '';
                }

                let string = text.replace(urlRegex, function(url,b,c) {
                    var url2 = (c == 'www.') ?  'http://' +url : url;
                    return '<a href="' +url2+ '" target="_blank">' + url + '</a>';
                });
                return string;
            },
            // delete review
            deleteReview(id,index) {
                $("#feed_story_" + index).show();
                this.axios.post('reviews/delete/' + id)
                    .then(response => {
                        // console.log(response)
                        window.eventBus.$emit('loadFeeds', true);
                        // this.feeds.splice(this.feeds.indexOf(index), 1);
                        return response;
                    })
                    .catch(error => {
                        // console.log(error)
                        return error;
                    })
            },
            // get fixtures for i=fixture id
            getFixtures(match) {
                const det = `${match.home_team_name} VS ${match.away_team_name}`;
                return det
            },
            cancleComment(index) {
                $("#comment" + index + " textarea").val("");
                $("#comment" + index + " .commentResponse").html("");
            },
            // post users review comment
            setReviewComment(review_id, index) {
                var comment = this.formModelComment.comment;
                const request_payload = {
                    comment: comment,
                    review_id: review_id,
                };
                $("#commentBtn_" + index).html("Submitting...");
                $("#commentBtn_" + index).attr("disabled", true);
                $("#comment" + index + " .commentResponse").html("");
                this.axios
                    .post("review/comment/add", request_payload)
                    .then(response => {
                        // console.log('response ', response.data.message);
                        $("#commentBtn_" + index).html("Post Comment");
                        $("#commentBtn_" + index).attr("disabled", false);
                        $("#comment" + index + " textarea").val("");
                        $("#comment" + index + " .commentResponse").html(
                            response.data.message
                        );

                        window.eventBus.$emit("loadFeeds", true);

                        // toggle bet show and hide of comment list
                        $(".comments-list").toggleClass("hide");
                        // toggle bt hide and show of comment box
                        $("#comment" + index).toggleClass("hide");
                        // clear response message
                        $("#comment" + index + " .commentResponse").html("");
                        // clear text box
                        $("#comment" + index + " textarea").val("");

                    })
                    .catch(error => {
                        // console.log(error);
                        $("#commentBtn_" + index).html("Post Comment");
                        $("#commentBtn_" + index).attr("disabled", false);
                        $("#comment" + index + " .commentResponse").html(
                            error.response.data.data
                        );
                    });
            },
            // set id for individual review post card
            commentBtn(index) {
                return "commentBtn_" + index;
            },
            // set id for individual review post card
            likeBtn(index) {
                return "likeBtn_" + index;
            },
            // like a review post
            likeReview(feed_id, index) {
                var api;
                if ($("#likeBtn_" + index).hasClass("liked")) {
                    api = `review/unlike/${feed_id}`;
                    // unlike the post
                    this.axios
                        .get(api)
                        .then(response => {
                            // console.log(response);
                            $("#likeBtn_" + index).removeClass("liked");
                            var likeVal = $("#like_count_" + index).html();
                            var calcu = isNaN(parseInt(likewhVal)) ? 0 : parseInt(likeVal);
                            var sum = calcu - 1;
                            $("#like_count_" + index).html(sum);
                            return response;
                        })
                        .catch(error => {
                            return error;
                            // console.log(error);
                        });
                } else {
                    api = `review/like/${feed_id}`;
                    // like the post
                    this.axios
                        .get(api)
                        .then(response => {
                            // console.log(response);
                            $("#likeBtn_" + index).addClass("liked");
                            var likeVal = $("#like_count_" + index).html();
                            var calcu = isNaN(parseInt(likeVal)) ? 0 : parseInt(likeVal);
                            var sum = calcu + 1;
                            $("#like_count_" + index).html(sum);
                            return response;
                        })
                        .catch(error => {
                            return error;
                            // console.log(error);
                        });
                }
            },
        },
    }
</script>

<style scoped>

</style>